import {reactive} from 'vue'
import {changePwdApi} from '@/api/common'
import { ElMessage } from 'element-plus'
import {getUserInfo} from '@/utils/util'

export default  function useWrapper(){
  interface IRawData {
    form:{
      Password:string,
      PassConfirm:string,
      NewPwd:string,
    },
    rules:any
  }

  const rawData = reactive<IRawData>({
    form:{
      Password:'',
      PassConfirm:'',
      NewPwd:''
    },
    rules:{
      Password:[
        { required: true, message: '这是一个必填项', trigger: 'blur' },
        { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
      ],
      NewPwd:[
        { required: true, message: '这是一个必填项', trigger: 'blur' },
        { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
      ],
      PassConfirm:[
        { required: true, message: '这是一个必填项', trigger: 'blur' },
        { validator: confirmPwd, trigger: 'blur' }
      ]
    }
  })
  function confirmPwd(rule:any, value:any, callback:any){
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== rawData.form.NewPwd) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  }


  function submitForm(ruleForm:any){
    ruleForm.validate((valid: any)=>{
      if(valid){
        const data = rawData.form
        changePwdApi(data).then((res:any)=>{
          if(res && res.state===0){
            ElMessage.success('密码修改成功')
            rawData.form = {
              Password:'',
              PassConfirm:'',
              NewPwd:'',
            }
          }
        })
      }else{
        ElMessage.error('保存失败，请仔细填写信息');
        return false
      }
    })
  }



  return {
    rawData,submitForm
  }
} 